/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Credentials
 */
export interface Credentials {
    /**
     * 
     * @type {boolean}
     * @memberof Credentials
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Credentials
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof Credentials
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof Credentials
     */
    username?: string;
}

/**
 * Check if a given object implements the Credentials interface.
 */
export function instanceOfCredentials(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CredentialsFromJSON(json: any): Credentials {
    return CredentialsFromJSONTyped(json, false);
}

export function CredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Credentials {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function CredentialsToJSON(value?: Credentials | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'password': value.password,
        'tenant': value.tenant,
        'username': value.username,
    };
}

